import { render } from "./Settings.vue?vue&type=template&id=0d8cc57e&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=0d8cc57e&scoped=true&lang=css"

import exportComponent from "/Users/bobbarnard/Documents/sources/bungalow7-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d8cc57e"]])

export default __exports__